import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectPlan, setPlan } from '../paywallSlice';
import { selectEventsData, selectOfferType } from '../../onboarding/onboardingSlice';
import { selectUserInfo } from '../../login/loginSlice';
import { BestLabel, Description, SaveAmount, StyledLi, StyledList, StyledOldValue, StyledPerWeek, StyledPeriod, StyledPrice, StyledValue, Title } from './styles/defaultStyles';
import AppTimer from './components/AppTimer';
import AppTimerShort from './components/AppTimerShort';
import AppButton from './components/AppButton';
import PlansDescription from './PlansDescription';
import { SelectedIcon, WhiteIcon } from './styles/icons';

const DefaultGzPlans = ({ onBuyClick }) => {
    const dispatch = useDispatch();
    const amplitudeEventData = useSelector(selectEventsData);
    const plan = useSelector(selectPlan);
    const landingType = useSelector(selectOfferType);
    const userInfo = useSelector(selectUserInfo);
    const displayedName = decodeURIComponent(userInfo?.name || amplitudeEventData?.user_email).split('@')[0];

    const fullPricePlans = useMemo(
        () => [
            {
                id: 'gz-1-month-3999',
                title: '1',
                period: 'month',
                price: '$9.99',
                week: 'per week',
                label: 'most popular',
            },
            {
                id: 'gz-3-month-5999',
                title: '3',
                period: 'months',
                price: '$4.99',
                week: 'per week',
            },
            {
                id: 'gz-6-month-panther',
                title: '6',
                period: 'months',
                price: '$2.99',
                week: 'per week',
            },
        ],
        []
    );
    const DEFAULT_PLANS = useMemo(
        () => ({
            gz_fullPrice: fullPricePlans,
            gz_main: fullPricePlans,
            gz_getmain: fullPricePlans,
            gz_anim: fullPricePlans,
            gz_new: [
                {
                    id: 'gz-6-month-3599',
                    title: '6',
                    period: 'months',
                    price: '$1.49',
                    oldPrice: '$2.99',
                    week: 'per week',
                    label: 'special for you',
                    saveAmount: '76%',
                },
                {
                    id: 'gz-3-months-2999',
                    title: '3',
                    period: 'months',
                    price: '$2.49',
                    oldPrice: '$4.99',
                    week: 'per week',
                },
                {
                    id: 'gz-1-month-1999',
                    title: '1',
                    period: 'month',
                    price: '$4.99',
                    oldPrice: '$9.99',
                    week: 'per week',
                },
            ],
        }),
        [fullPricePlans]
    );
  
    const currentPlans = useMemo(
        () => DEFAULT_PLANS[landingType],
        [landingType, DEFAULT_PLANS]
    );

    useEffect(() => {
        dispatch(setPlan(currentPlans[0].id));
    }, [dispatch, currentPlans]);
  
    const onPlanClick = (id) => dispatch(setPlan(id));
    const renderOffer = (i, index) => {
        const isActive = plan === i.id;
        return (
            <StyledLi
                active={isActive}
                onClick={() => onPlanClick(i.id)}
                key={i.id}
                id={`plan-button-${index + 1}`}
            >
                <StyledPeriod active={isActive}>
                    <div>{isActive ? SelectedIcon : WhiteIcon}</div>
                    <span>
                        {i.title} {i.period}
                    </span>
                </StyledPeriod>
                <StyledPrice active={i.label} withLabel={i.saveAmount}>
                    {i.oldPrice && <StyledOldValue>{i.oldPrice}</StyledOldValue>}
                    <StyledValue>{i.price}</StyledValue>
                    <StyledPerWeek>{i.week}</StyledPerWeek>
                </StyledPrice>
                {i.label && <BestLabel>{i.label}</BestLabel>}
                {i.saveAmount && (
                    <SaveAmount>
                        save {i.saveAmount}
                    </SaveAmount>
                )}
            </StyledLi>
        );
    };
    const continueButton = (displayStickyBtn, sticky) => (
        <AppButton
            onClick={onBuyClick}
            bottomPosition={'24px'}
            displayStickyBtn={displayStickyBtn}
            position={sticky}
            customStickyWidth={'100%'}
            customBeforeHeight={'0px'}
            displayStubBtn={false}
        >
            Continue
        </AppButton>
    );
     
    return (
        <>
            <Title>
                <span>Hey</span>&nbsp;{displayedName}!
            </Title>
            <Description>Based on your answers, we’ve made the best program for your family’s safety!</Description>
            {landingType === 'gz_new' ? <AppTimer /> : <AppTimerShort />}
            <StyledList>{currentPlans.map(renderOffer)}</StyledList>
            {continueButton(true, 'sticky')}
            <PlansDescription continueButton={continueButton} />
        </>
    );
};

export default DefaultGzPlans;
